module.exports = __webpack_public_path__ + "img/alipay.29fe3f07.png";